/* global Lang */

import React, { useState } from 'react';

import Card, { CardBody } from '../Card';
import calculateHeroLevel from '../../../common/utilities/calculateHeroLevel';
import HeroPowerUsage from '../HeroPowerUsage';
import ClickOutside from '../../../common/utilities/ClickOutside';
import HeroAvatar from '../HeroAvatar';

const PlayerDomainHeroes = ({
  className = '', domains, powers, allPowers, estimations,
}) => {
  const [selectedHero, setSelectedHero] = useState(null);

  return (
    <ClickOutside onClickOutside={() => setSelectedHero(null)}>
      <div className="position-relative mb-3">
        <Card className={className}>
          <CardBody className="p-0">
            <table className="table table-striped mb-0 w-100">
              <thead className="thead-dark">
                <tr>
                  <th>{Lang.get('messages.dashboard.hero')}</th>
                  <th>{Lang.get('messages.dashboard.domain')}</th>
                  <th>{Lang.get('messages.dashboard.level')}</th>
                  <th>{Lang.get('messages.dashboard.powers')}</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {domains
                  .filter(({ hero }) => !!hero)
                  .sort((a, b) => estimations.all[b.slug] - estimations.all[a.slug])
                  .map(({ hero, slug, title }) => (
                    <tr
                      key={slug}
                      className={selectedHero === hero ? 'table-active' : ''}
                      onClick={() => {
                        if (hero !== selectedHero) {
                          setSelectedHero(hero);
                        } else {
                          setSelectedHero(null);
                        }
                      }}
                    >
                      <td className="align-middle">
                        <HeroAvatar className="btn btn-small" {...hero} size={36} />
                      </td>
                      <td className="align-middle">
                        <strong>{hero.name}</strong>
                        <div>{title}</div>
                      </td>
                      <td className="align-middle">{calculateHeroLevel(slug, estimations.all)}</td>
                      <td className="align-middle">{Object.keys(powers[slug] || []).length}</td>
                      <td className="align-middle pr-0">
                        <button
                          className={selectedHero === hero ? 'btn btn-secondary' : 'btn'}
                          type="button"
                        >
                          <i className="fas fa-search" />
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </CardBody>
        </Card>
        {selectedHero && (
          <HeroPowerUsage hero={selectedHero} allPowers={allPowers} usedPowers={powers} />
        )}
      </div>
    </ClickOutside>
  );
};

export default PlayerDomainHeroes;
